import { TabType } from 'components/Tabs';

import { Data } from './components/Data';
import { Categories } from './components/Categories';
import { Zone } from './components/Zone';
import { BillingAddress } from './components/BillingAddress';
import { ShippingAddress } from './components/ShippingAddress';
import { Images } from './components/Images';
import { Permissions } from './components/Permissions';

const generateTabs = (id?: string, isShippingAddress?: boolean): TabType[] => [
  {
    id: 1,
    title: 'User Data',
    content: <Data />,
  },
  {
    id: 2,
    title: 'Permissions',
    content: <Permissions />,
    isDisabled: !id,
  },
  {
    id: 3,
    title: 'Seasons and lines',
    content: <Categories />,
    isDisabled: !id,
  },
  {
    id: 4,
    title: 'Zone',
    content: <Zone />,
    isDisabled: !id,
  },
  {
    id: 5,
    title: 'Billing address',
    content: <BillingAddress />,
    isDisabled: !id,
  },
  {
    id: 6,
    title: 'Shipping address',
    content: <ShippingAddress />,
    isHidden: !isShippingAddress,
    isDisabled: !id,
  },
  {
    id: 7,
    title: 'Images',
    content: <Images />,
    isHidden: !id,
  },
];

export { generateTabs };
